import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {  DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  bodyRowWidth: any;
  checkWidth: any;
  constructor(private router: Router,
    @Inject(DOCUMENT) private document: any) {

      if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) {
        if (window.innerWidth >= 980) {
          this.checkWidth = 980;
        }else {
          this.checkWidth =  window.innerWidth;
        }
      }else {
        this.checkWidth = 980;
      }
    }
  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts